import getEnv from '../../services/util/getEnv';

const originalFetch = require('isomorphic-fetch');
const fetch = require('fetch-retry')(originalFetch);
const MatchingURL = getEnv('REACT_APP_MATCHING_API_URL') || 'http://localhost:4001/api'

const MAX_RETRIES = 3;
const EXPONENTIAL_BACK_OFF = 1.5;

const getHeaders = (passedHeaders) => {
  const token = localStorage.getItem('token');
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
    ...passedHeaders,
  };
  return headers;
};

const makeRequest = (url, options, headers = null) => {
  const retry = {
    retryOn: (attempt, error, response) => {
      if (attempt === MAX_RETRIES) {
        return false;
      }
      if (error !== null || response.status >= 501) {
        return true;
      }
    },
    retryDelay: (attempt) => {
      return EXPONENTIAL_BACK_OFF ** attempt * 100;
    },
  };

  return new Promise((resolve, reject) => {
    fetch(url.startsWith('http') ? url : `${MatchingURL}${url}`, {
      ...options,
      ...retry,
      // credentials: 'same-origin',
      headers: getHeaders(headers),
    })
      .then(async (response) => {
        const { ok, status } = response;
        const statusWithEmptyBody = [204, 205];
        if (statusWithEmptyBody.includes(status)) {
          return resolve({ status });
        }
        const responseJson = await response.json();
        if (
          response.status === 401 &&
          ['Invalid Token', 'Unauthorized'].includes(responseJson.message)
        ) {
          throw new Error("Unauthorized, please login");
        }
        if (ok) {
          const res = responseJson;
          res.httpStatus = status;
          res.httpCode = status;
          return resolve(res);
        }
        return reject(responseJson);
      })
      .catch((err) => {
        console.log("Error", err)
        reject(err);
      });
  });
};

export const MatchingService = {
  getDefaultHeaders: () => {
    return getHeaders();
  },
  postFormData: (url, data) => {
    const headers = getHeaders();
    headers.delete('Content-Type');
    return makeRequest(
      url,
      {
        body: data,
        method: 'POST',
      },
      headers,
    );
  },

  post: (url, data, headers, keepAlive = false) => {
    return makeRequest(
      url,
      {
        body: JSON.stringify(data),
        method: 'POST',
        ...(keepAlive ? { keepalive: true } : {}),
      },
      headers,
    );
  },

  put: (url, data, headers) => {
    return makeRequest(
      url,
      {
        body: JSON.stringify(data),
        method: 'PUT',
      },
      headers,
    );
  },
  patch: (url, data, headers) => {
    return makeRequest(
      url,
      {
        body: JSON.stringify(data),
        method: 'PATCH',
      },
      headers,
    );
  },
  get: (url, headers) => {
    return makeRequest(
      url,
      {
        method: 'GET',
      },
      headers,
    );
  },
  delete: (url, data = {}) => {
    return makeRequest(url, {
      body: JSON.stringify(data),
      method: 'DELETE',
    });
  },
};
